import { post, get } from "@/request/request"

import { IBaseRespone } from "types/api"

interface OauthBindInfo {
    oAuthPlatformType?: number;
    corpId?: string;
    userId?: string;
}



export function getSelfAccountInfo() {
  return post<IBaseRespone<{
		oldAccount: boolean;
		tenantId: string;
		tenantName: string;

		employeeId: number

		//编号
    employeeNo: string;

		//昵称
    nickname: string;

		// 姓名
    name: string;

		mobileFuzzy: string;

		emptyPwd: boolean;

    //员工权限 0:无权限 1:可以访问 2: 可以操作
    permission: number;

    //oauth三方绑定信息
    oauthBindList: OauthBindInfo[];
	}>>(
    "/api/tm/unified-login/v5/admin/employee/getSelfInfo",
    {}
  )
}

export function unbindOauth(
    params: {
        oauthPlatformType: string
    }
) {
    return post<IBaseRespone<any>>(
        "/api/tm/unified-login/v5/admin/employee/unbindOauth",
        params
    )
}


/*
  修改自己绑定的手机号
 */
export function sendChangeMobileSms(
  params: {
    mobile: string
    captchaId?: number
  }) {
  return post<IBaseRespone<string>>(
    "/api/tm/unified-login/v5/admin/employee/sendChangeMobileSms",
    params
  )
}

export function verifyAuthCodeForChangeMobile(
  params: {
    authKey: string
    authCode: string
  }
) {
  return post<IBaseRespone<any>>(
    "/api/tm/unified-login/v5/admin/employee/verifyAuthCodeForChangeMobile",
    params
  )
}
export function verifyAuthCodeAndChangeMobile(
  params: {
    authKey: string
    authCode: string
  }
) {
  return post<IBaseRespone<any>>(
    "/api/tm/unified-login/v5/admin/employee/verifyAuthCodeAndChangeMobile",
    params
  )
}

// export function downloadDocApi(
//   timeout: number
// ) {
//   return post<IBaseRespone<any>>(
//     "api/tm/unified-login/v1/auth/employee/template-download",
//     {},
//     {
//       responseType: 'blob',
//       timeout: timeout,
//     }
//   )
// }
